var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { docReady } from './doc-ready';
import { getAvailableStores } from './currencies';
let allStores = [];
let allMarkets = [];
export const getStores = () => {
    return allStores;
};
export const getMarkets = () => {
    return allMarkets;
};
const queryMarkets = () => __awaiter(void 0, void 0, void 0, function* () {
    if (allMarkets.length === 0) {
        const currentVersion = localStorage.getItem('TH-stores_V-market');
        const marketsStorage = localStorage.getItem('TH-markets');
        if (currentVersion && currentVersion === `${window.thGeolocationData.version}` && marketsStorage) {
            allMarkets = JSON.parse(localStorage.getItem('TH-markets'));
            allMarkets.forEach((region, index) => {
                window.thGeolocationData.markets[index].codes = region.codes;
                window.thGeolocationData.markets[index].redirect_domain = region.redirect_domain;
                window.thGeolocationData.markets[index].name = region.name;
            });
        }
        else {
            allMarkets = window.thGeolocationData.markets;
            localStorage.setItem('TH-markets', JSON.stringify(window.thGeolocationData.markets));
            localStorage.setItem('TH-stores_V-market', `${window.thGeolocationData.version}`);
        }
    }
    return allMarkets;
});
const queryStores = () => __awaiter(void 0, void 0, void 0, function* () {
    if (allStores.length === 0) {
        const currentVersion = localStorage.getItem('TH-stores_V');
        if (currentVersion && currentVersion === `${window.thGeolocationData.version}`) {
            allStores = JSON.parse(localStorage.getItem('TH-stores'));
            allStores.forEach((region, index) => {
                return Object.assign(Object.assign({}, region), { availableCountries: window.thGeolocationData.stores[index].availableCountries, defaultCountry: window.thGeolocationData.stores[index].defaultCountry });
            });
        }
        else {
            const localizationData = yield Promise.all(window.thGeolocationData.stores.map((store) => __awaiter(void 0, void 0, void 0, function* () { return yield getAvailableStores(store.permanent_domain, store.s); })));
            if (localizationData) {
                localizationData.forEach((region, index) => {
                    window.thGeolocationData.stores[index].availableCountries = region.availableCountries;
                    window.thGeolocationData.stores[index].defaultCountry = region.defaultCountry;
                });
                allStores = window.thGeolocationData.stores;
                localStorage.setItem('TH-stores', JSON.stringify(window.thGeolocationData.stores));
                localStorage.setItem('TH-stores_V', `${window.thGeolocationData.version}`);
            }
        }
    }
    return allStores;
});
export function setGeolocationDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
        yield queryStores();
        yield queryMarkets();
        if (sessionStorage.getItem('countryCode') === null) {
            const response = yield fetch('https://thread-ip.azurewebsites.net/api/ip');
            const data = yield response.json();
            sessionStorage.setItem('countryName', data.country);
            sessionStorage.setItem('countryCode', data.countryCode);
        }
    });
}
docReady(() => __awaiter(void 0, void 0, void 0, function* () {
    yield queryStores();
    yield queryMarkets();
}));
